import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-158e2e68"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "inner-container"
};
var _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["swiper-header-container", {
      'disable-auto': !_ctx.autoRef
    }])
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["swiper-item", {
        active: item.active
      }]),
      key: index,
      onClick: function ($event) {
        return _ctx.onClickItem(item, index);
      }
    }, _toDisplayString(item.activityTypeName), 11, _hoisted_2);
  }), 128))])], 2);
}